/**
 * Oklahoma state palette.
 *
 * `stateBlue` is verified: it appears as #004e9a in oklahoma.gov's own
 * `clientlib-base` stylesheet. The remaining four are derived from the state
 * flag and brand usage and are NOT yet confirmed against the official Oklahoma
 * brand guide. Confirm before this is shown outside the team.
 *
 * The state seal and star device are official marks of the State of Oklahoma.
 * This application uses the palette only, ships its own wordmark, and carries an
 * unofficial-prototype notice. Do not add state insignia.
 */
export const OK = {
  /** Verified from oklahoma.gov. */
  stateBlue: '#004e9a',
  /** Unverified - confirm against the brand guide. */
  darkBlue: '#00274c',
  green: '#78a22f',
  red: '#c8102e',
  gold: '#ffb81c',
} as const;

/** Neutrals, tuned to sit against the state blue rather than pure gray. */
export const NEUTRAL = {
  paperLight: '#ffffff',
  bgLight: '#f4f6f8',
  paperDark: '#12202f',
  bgDark: '#0b1620',
  borderLight: '#d8dee5',
  borderDark: '#22364a',
  textLight: '#16202a',
  textDark: '#e8eef4',
  textMutedLight: '#54636f',
  textMutedDark: '#9fb0be',
} as const;
